<div class="breadcrum-container w-full px-4 sm:px-6 lg:px-8 bg-white">
  <app-breadcrum [data]="cartBreadcrumbs" (breadcrumbClick)="onBreadcrumbClick($event)">
  </app-breadcrum>
</div>
<main class="flex flex-col bg-white pb-36 md:pb-8">
  <section class="w-full max-w-full px-4 sm:px-6 lg:px-8 pt-2 md:pt-4 pb-6">
    <div class="MidSec flex flex-col lg:flex-row gap-4 lg:gap-6 items-start"
      *ngIf="isCartLoading || !isCartEmpty() || payment">
      <!-- Keep column visible during loading to avoid blank flicker -->
      <div class="LeftSide w-full lg:w-9/12 min-w-0 lg:overflow-y-auto lg:max-h-[calc(100vh-120px)]" *ngIf="!payment">
        <div class="flex flex-col w-full max-md:max-w-full">
          <!-- Delivery Address Card -->
          <section *ngIf="isLogging && shouldShowDeliverySection()"
            class="w-full rounded-xl bg-[#F8FAFC] border border-[#E2E8F0] p-3.5 sm:p-4 shadow-xs">
            <div class="flex items-center justify-between gap-3 pb-2.5">
              <div class="flex flex-wrap items-center gap-2 min-w-0 flex-1">
                <span
                  class="inline-flex items-center text-xs sm:text-sm font-bold text-[#0A0A5F] px-2.5 py-0.5 rounded-md whitespace-nowrap">
                  Deliver to:
                </span>
                <span
                  class="text-sm sm:text-[15px] font-semibold text-gray-900 truncate max-w-[200px] sm:max-w-[340px]">
                  {{ userData?.shipping_address?.receiver_name || userData?.shipping_address?.company_name ||
                  userData?.account_name }}
                </span>
                <span *ngIf="userData?.shipping_address?.pincode"
                  class="text-xs sm:text-sm font-medium text-gray-500 whitespace-nowrap">
                  - {{ userData?.shipping_address?.pincode }}
                </span>
                <span *ngIf="userData?.shipping_address?.address_type"
                  class="px-2 py-0.5 text-xs font-medium bg-white border border-gray-200 rounded-full text-gray-600 shadow-2xs whitespace-nowrap">
                  {{ userData?.shipping_address?.address_type | titlecase }}
                </span>
              </div>
              <button type="button"
                class="shrink-0 text-xs sm:text-sm font-semibold text-[#0A0A5F] bg-white border border-[#0A0A5F] rounded-lg px-3.5 py-1 hover:bg-blue-50 transition-colors shadow-2xs cursor-pointer active:scale-95"
                (click)="selectAddress('shipping')">
                Change
              </button>
            </div>
            <div class="pt-2 text-xs sm:text-sm text-gray-600 leading-relaxed">
              <address class="not-italic">
                {{ formatAddress(userData?.shipping_address) }}
              </address>
              <div *ngIf="isLogging && userData?.billing_address?.id === userData?.shipping_address?.id"
                class="mt-2 text-xs text-blue-800 bg-blue-50/70 border border-blue-100 rounded-md px-2.5 py-1.5 flex items-center gap-1.5">
                <svg class="w-3.5 h-3.5 shrink-0 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                    clip-rule="evenodd" />
                </svg>
                <span>Note: Delivery details and billing details will be the same.</span>
              </div>
            </div>
          </section>

          <!-- Billing Address Card -->
          <section *ngIf="isLogging && shouldShowCartBillingSection()"
            class="w-full mt-3 rounded-xl bg-[#F8FAFC] border border-[#E2E8F0] p-3.5 sm:p-4 shadow-xs">
            <div class="flex items-center justify-between gap-3 pb-2.5">
              <div class="flex flex-wrap items-center gap-2 min-w-0 flex-1">
                <span
                  class="inline-flex items-center text-sm font-bold text-[#0A0A5F] px-2.5 py-0.5 rounded-md whitespace-nowrap">
                  Billing to:
                </span>
                <span class="text-sm sm:text-base font-semibold text-gray-900 truncate max-w-[200px] sm:max-w-[340px]">
                  {{ getCartBillingAddress()?.company_name || getCartBillingAddress()?.receiver_name ||
                  userData?.account_name }}
                </span>
                <span *ngIf="getCartBillingAddress()?.pincode"
                  class="text-sm font-medium text-gray-500 whitespace-nowrap">
                  - {{ getCartBillingAddress()?.pincode }}
                </span>
                <span *ngIf="getCartBillingAddress()?.address_type"
                  class="px-2 py-0.5 text-xs font-medium bg-white border border-gray-200 rounded-full text-gray-600 shadow-2xs whitespace-nowrap">
                  {{ getCartBillingAddress()?.address_type | titlecase }}
                </span>
              </div>
              <button type="button"
                class="shrink-0 text-sm font-semibold text-[#0A0A5F] bg-white border border-[#0A0A5F] rounded-lg px-3.5 py-1 hover:bg-blue-50 transition-colors shadow-2xs cursor-pointer active:scale-95"
                (click)="selectAddress('billing')">
                Change
              </button>
            </div>
            <div class="pt-2 text-sm text-gray-600 leading-relaxed">
              <address class="not-italic">
                {{ formatAddress(getCartBillingAddress()) }}
              </address>
              <div *ngIf="userData?.billing_address?.gstin_number" class="mt-2 pt-2 flex items-center gap-2 text-sm">
                <span class="text-gray-500 font-medium">GSTIN:</span>
                <span class="font-bold text-gray-900 tracking-wider">{{ userData?.billing_address?.gstin_number
                  }}</span>
              </div>
            </div>
          </section>

          <!-- Add Address Prompt -->
          <div *ngIf="isLogging && shouldShowAddAddressPrompt()"
            class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 p-3.5 sm:p-4 mt-4 bg-[#F5F9FE] border border-blue-100 rounded-xl">
            <div class="flex items-center gap-2.5 min-w-0">
              <svg class="w-5 h-5 text-[#0A0A5F] shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span class="text-sm sm:text-base font-bold text-[#0A0A5F]">
                {{
                hasOnlyStorePickupItems()
                ? "Add billing address for invoice & pickup"
                : "Add address to check for delivery & services"
                }}
              </span>
            </div>
            <button
              class="self-stretch sm:self-auto px-4 py-1.5 text-xs sm:text-sm font-semibold text-[#0A0A5F] bg-white border border-[#0A0A5F] rounded-lg hover:bg-blue-50 transition-colors whitespace-nowrap shrink-0 shadow-2xs cursor-pointer"
              (click)="
                selectAddress(
                  hasOnlyStorePickupItems() ? 'billing' : 'shipping'
                )
              ">
              Add new address
            </button>
          </div>

          <!-- Address Option Pills -->
          <div *ngIf="
              isLogging &&
              (shouldShowDeliverySection() || hasOnlyStorePickupItems())
            " class="flex flex-wrap gap-3 items-center mt-3.5 w-full">
            <!-- Radio 1: Add different Billing details -->
            <label (click)="selectAddress('billing'); $event.preventDefault()"
              class="inline-flex items-center gap-2.5 px-3 py-2 rounded-lg bg-white hover:bg-gray-50 active:bg-gray-100 cursor-pointer transition-colors touch-manipulation select-none shadow-2xs min-h-[44px]">
              <input type="radio" id="billing" name="invoiceOption" value="billing"
                [checked]="selectedOption === 'billing'"
                class="w-4 h-4 accent-[#0A0A5F] cursor-pointer pointer-events-none" />
              <span class="text-sm font-semibold text-gray-800 cursor-pointer">
                Add different Billing details
              </span>
            </label>

            <!-- Radio 2: Add GSTIN invoice -->
            <label *ngIf="canAddGstDetails" (click)="gstmodel(); $event.preventDefault()"
              class="inline-flex items-center gap-2.5 px-3 py-2 rounded-lg bg-white hover:bg-gray-50 active:bg-gray-100 cursor-pointer transition-colors touch-manipulation select-none shadow-2xs min-h-[44px]">
              <input type="radio" id="gstin" name="invoiceOption" value="gstin" [checked]="selectedOption === 'gstin'"
                class="w-4 h-4 accent-[#0A0A5F] cursor-pointer pointer-events-none" />
              <span class="text-sm font-semibold text-gray-800 cursor-pointer">
                Add GSTIN
              </span>
            </label>
          </div>

          <!-- Select All / Remove All Section -->
          <section class="mt-6 w-full">
            <div class="flex justify-between items-center px-1 pb-3 w-full border-b border-gray-200">
              <label for="selectAll" class="inline-flex items-center gap-2.5 cursor-pointer select-none">
                <input *ngIf="getValidCartItems().length > 0" type="checkbox" id="selectAll" name="selectAll"
                  [checked]="selectAllChecked" (change)="onSelectAllChangeEvent($event)" [disabled]="isCartEmpty()"
                  class="w-4 h-4 rounded text-blue-600 accent-[#0A0A5F] cursor-pointer" />
                <span class="text-base sm:text-lg font-bold text-gray-800">
                  {{ getSelectionText() }}
                </span>
              </label>
              <button class="text-xs sm:text-sm font-semibold transition-colors" [ngClass]="
                  getSelectedCount() === 0
                    ? 'text-gray-400 cursor-not-allowed'
                    : 'text-blue-600 hover:text-blue-800 cursor-pointer'
                " (click)="confirmRemoveAll()" [disabled]="getSelectedCount() === 0">
                <span>Remove All</span>
              </button>
            </div>

            <!-- Skeleton while cart is loading -->
            <div *ngIf="isCartLoading" class="mt-4 space-y-3">
              <div class="h-24 rounded-lg bg-gray-100 animate-pulse"></div>
              <div class="h-24 rounded-lg bg-gray-100 animate-pulse"></div>
              <div class="h-24 rounded-lg bg-gray-100 animate-pulse"></div>
            </div>

            <ng-container *ngIf="!isCartLoading && !isCartEmpty()">
              <app-select-cart *ngFor="let item of getValidCartItems()" [item]="item"
                [isSelected]="isItemSelected(item)" (selectionChange)="onItemSelectionChange($event)"
                (remove)="onItemRemoved()"></app-select-cart>
            </ng-container>
          </section>
        </div>

        <!-- Add more from Wishlist (inside LeftSide) -->
        <div *ngIf="
            isLogging &&
            wishlistItems.length > 0 &&
            (isWishlistLoading || wishlistItems.length > 0)
          " class="w-full mt-4 mb-3">
          <div class="w-full rounded-xl bg-gray-100 border border-gray-200">
            <button type="button" class="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
              (click)="toggleWishlistSection()">
              <div class="flex items-center gap-2.5">
                <!-- Bookmark Icon -->
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                  stroke="#1a1a1a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="shrink-0">
                  <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
                </svg>
                <span class="text-base font-semibold text-[#1a1a1a]">
                  Add more from Wishlist
                </span>
              </div>
              <!-- Chevron -->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="#1a1a1a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="shrink-0 transition-transform duration-200" [ngClass]="{ 'rotate-180': isWishlistExpanded }">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>

            <div *ngIf="isWishlistExpanded">
              <div *ngIf="!isWishlistLoading && wishlistItems.length > 0" class="grid gap-4 px-4 pb-4 md:grid-cols-2">
                <article *ngFor="let item of wishlistItems" class="flex gap-4 rounded-xl p-3 flex-row">
                  <div class="relative flex w-full max-w-[100px] shrink-0">
                    <img [src]="
                        item?.part_image_path?.[0] ||
                        item?.part_image_path ||
                        'https://cdn.builder.io/api/v1/image/assets/TEMP/41b1ccfb35d1e0ac0f01c857c382a1354655da46?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7'
                      " [alt]="item | productName" class="max-h-[100px] w-full rounded-lg object-cover" />
                  </div>

                  <div class="flex flex-1 flex-col">
                    <div class="flex flex-col gap-1">
                      <h3 class="text-base font-semibold text-blue-950">
                        {{ item | productName }}
                      </h3>
                      <p *ngIf="getWishlistMeta(item)" class="text-sm font-medium text-gray-500">
                        {{ getWishlistMeta(item) }}
                      </p>
                    </div>

                    <div class="flex flex-col text-sm gap-2 text-gray-600 mt-1">
                      <ng-container *ngIf="getWishlistPricing(item) as priceInfo">
                        <div class="flex flex-wrap items-center gap-2">
                          <span class="text-base font-semibold text-blue-950">
                            {{
                            item?.discounted_price ? item?.discounted_price : item?.price_s
                            | currency : 'INR' : 'symbol-narrow' : '1.0-0'
                            }}
                          </span>
                          <span *ngIf="item?.discounted_price && item?.price_s && item?.discount_percentage > 0"
                            class="text-xs font-medium text-gray-400 line-through">
                            {{ item?.price_s | currency : 'INR' : 'symbol-narrow' : '1.0-0' }}
                          </span>
                          <span *ngIf="item?.discount_percentage > 0"
                            class="inline-flex items-center rounded-full bg-[#006C3B] px-2 py-0.5 text-xs font-semibold text-white">
                            {{ item?.discount_percentage }}% Off
                          </span>
                        </div>
                      </ng-container>
                      <p *ngIf="item?.seller_name" class="text-sm">
                        Sold by:
                        <span class="font-semibold text-blue-900">{{ item?.seller_name }}</span>
                      </p>
                    </div>

                    <div class="mt-2 flex flex-wrap gap-2">
                      <button type="button"
                        class="flex-1 max-w-[120px] rounded-lg border border-blue-900 px-3 py-1.5 text-sm font-semibold text-blue-900 whitespace-nowrap"
                        (click)="removeFromWishlist(item)">
                        Remove
                      </button>
                      <button type="button" (click)="moveToCart(item)"
                        class="flex-1 max-w-[120px] rounded-lg border border-blue-900 px-3 py-1.5 text-sm font-semibold text-blue-900 whitespace-nowrap">
                        Move to Cart
                      </button>
                    </div>
                  </div>
                </article>
              </div>

              <div *ngIf="!isWishlistLoading && wishlistItems.length === 0"
                class="flex items-center justify-center px-6 py-10 text-sm font-medium text-gray-500">
                Your wishlist is empty right now.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="LeftSide w-full lg:w-9/12 min-w-0 lg:overflow-y-auto lg:max-h-[calc(100vh-120px)]" *ngIf="payment">
        <app-payment (selectedPartNumbersChange)="onSelectedPartNumbersChange($event)"
          (priceDetailsChange)="onPriceDetailsChange($event)"></app-payment>
      </div>
      <div class="RightSide w-full lg:w-3/12 min-w-0 lg:sticky lg:top-4 lg:self-start"
        *ngIf="isCartLoading || !isCartEmpty()">
        <div class="w-full lg:sticky lg:top-20 self-start">
          <aside
            class="RightSide border-l border-solid border-l-[color:var(--Input-field-Stroke,#D4D4D4)] border-neutral-300 min-h-[412px] lg:pl-4 max-lg:pl-0 max-lg:border-l-0 max-lg:min-h-0">
            <!-- Apply Coupon Section -->
            <div class="flex flex-col justify-center p-3 w-full font-bold bg-blue-50 bg-opacity-50">
              <div class="flex gap-5 justify-between items-start w-full">
                <div class="flex gap-2 items-center">
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/e2edeb91e797a7c6025767a8194bdec2e333778f?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                    class="object-contain w-5 h-5" alt="Coupon icon" />
                  <div *ngIf="!selectedCoupon">
                    <h3 class="text-sm font-medium text-blue-950">
                      Apply Coupon
                    </h3>
                    <p class="text-xs text-emerald-800">
                      {{ availableCoupons.length > 0 ? availableCoupons.length + '+ Coupons available' : 'Coupons
                      available' }}
                    </p>
                  </div>
                  <div *ngIf="selectedCoupon">
                    <h3 class="text-sm font-medium text-blue-950">
                      {{ selectedCoupon?.coupon_code }}
                    </h3>
                    <p class="text-xs text-emerald-800">
                      You saved ₹{{ selectedCoupon?.savings }}
                    </p>
                  </div>
                </div>
                <button class="text-sm font-medium text-blue-600" (click)="couponmodel()">
                  {{ selectedCoupon ? 'Change' : 'View All' }}
                </button>
              </div>
            </div>

            <!-- Price Details Section -->
            <div class="px-4 pb-4 md:pb-0">
              <h3 class="text-base font-medium py-3 border-b border-gray-200">
                Price Details
              </h3>

              <div class="py-3 space-y-3 text-sm">
                <div class="flex justify-between">
                  <p class="text-gray-700">Sub Total</p>
                  <p class="font-medium">₹{{ getBasePrice() | number: '1.2-2' }}</p>
                </div>
                <div class="flex justify-between">
                  <p class="text-gray-700">
                    Scrap Booking Amount
                    <!-- <span *ngIf="getBookingPercentage()" class="text-xs font-bold text-blue-600 ml-1">
                      ({{ getBookingPercentage() }}%)
                    </span> -->
                  </p>
                  <p class="text-emerald-600 font-bold">
                    + ₹{{ priceDetails?.scrap_booking_amount ? priceDetails?.scrap_booking_amount :
                    priceDetails?.discountAmount}}
                  </p>
                </div>
                <label *ngIf="hasBookingAmount() || payFullAmount" class="flex items-start gap-2 cursor-pointer">
                  <input type="checkbox" class="mt-0.5 w-4 h-4 rounded border-gray-300" [(ngModel)]="payFullAmount"
                    (ngModelChange)="onPayFullAmountChange($event)" aria-label="Pay full amount now" />
                  <span class="text-gray-700">
                    Pay full amount now instead of booking amount.
                  </span>
                </label>
                <!-- <div *ngIf="hasBookingAmount() && !payFullAmount && getScrapBalanceAmount() > 0"
                  class="flex items-start gap-2 p-2.5 bg-blue-50/70 rounded-lg border border-blue-100 text-[#0A0A5F]">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="mt-0.5 shrink-0 text-blue-700">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                  </svg>
                  <p class="text-[#0A0A5F] font-medium text-xs leading-relaxed">
                    The balance amount of ₹{{ getScrapBalanceAmount() | number: "1.2-2" }} is to be paid at the time of store pickup.
                  </p>
                </div> -->
                <div class="flex justify-between">
                  <p class="text-gray-700">Discount on Base Price</p>
                  <p class="text-emerald-600">
                    - ₹{{ priceDetails?.discount ? priceDetails?.discount : '0'}}
                  </p>
                </div>
                <div class="flex justify-between" *ngIf="priceDetails?.offer_discount > 0">
                  <p class="text-gray-700">Coupon Discount</p>
                  <p class="text-emerald-600">
                    - ₹{{ priceDetails?.offer_discount }}
                  </p>
                </div>
                <div class="flex justify-between">
                  <p class="text-gray-700">Platform Charges</p>
                  <p>+ ₹{{ priceDetails?.platform_charges ? priceDetails?.platform_charges : '0'}}</p>
                </div>
                <div class="flex justify-between">
                  <p class="text-gray-700">Delivery Charges</p>
                  <p>{{ (priceDetails?.delivery_charges && priceDetails?.delivery_charges > 0) ? '+ ₹' +
                    (priceDetails?.delivery_charges) : 'Free' }}</p>
                </div>
                <div class="flex justify-between border-b border-gray-200 pb-3">
                  <p class="text-gray-700">GST</p>
                  <p>+ ₹{{ priceDetails?.gst_amount ? priceDetails?.gst_amount : '0' }}</p>
                </div>
                <div class="flex justify-between border-b border-gray-200 pb-3" *ngIf="priceDetails?.tcs_amount > 0">
                  <p class="text-gray-700">TCS</p>
                  <p>+ ₹{{ priceDetails?.tcs_amount ? priceDetails?.tcs_amount : '0' }}</p>
                </div>
                <div class="flex justify-between pt-1">
                  <p class="font-medium">Total Amount</p>
                  <p class="font-medium">₹{{ getDisplayTotalAmount() }}</p>
                </div>
              </div>

              <div *ngIf="paymentErrorMessage"
                class="mt-3 px-3 py-2 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm">
                {{ paymentErrorMessage }}
              </div>
              <button *ngIf="lable === 'Make Payment'" (click)="onMakeEnquiry()"
                [disabled]="selectedItems.size === 0 || (payment && userData && !canPlaceOrder)"
                [class.opacity-60]="selectedItems.size === 0 || (payment && userData && !canPlaceOrder)"
                class="hidden md:flex gap-1 justify-center items-center p-3 mt-3 w-full text-base font-bold text-center text-white rounded-lg bg-[#0A0A5F] hover:bg-blue-900 transition-colors cursor-pointer">
                <span class="gap-2 self-stretch my-auto text-white">
                  Enquire Now
                </span>
              </button>
              <button (click)="gotoPayment()" [disabled]="payment && userData && !canPlaceOrder"
                [class.opacity-60]="payment && userData && !canPlaceOrder"
                class="hidden md:flex gap-1 justify-center items-center p-3 mt-3 mb-4 w-full text-base font-medium text-white whitespace-nowrap rounded-lg bg-[#0A0A5F] hover:bg-blue-900 transition-colors cursor-pointer">
                {{ lable }}
              </button>
            </div>
          </aside>
        </div>
      </div>
    </div>

    <!-- Empty Cart State -->
    <div *ngIf="!payment && !isCartLoading && isCartEmpty()"
      class="w-full flex flex-col items-center justify-center py-10 sm:py-16 px-4">
      <div class="w-full max-w-xl bg-white rounded-2xl p-6 sm:p-10 shadow-xs flex flex-col items-center text-center">
        <!-- Cart Icon Illustration -->
        <div
          class="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center mb-5 text-[#0A0A5F]">
          <svg class="w-10 h-10 sm:w-12 sm:h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24"
            stroke-width="1.6">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-1.5 6h13m-10.5 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm9 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z" />
          </svg>
        </div>

        <!-- Heading & Description -->
        <h2 class="text-xl sm:text-2xl font-bold text-gray-900 mb-2">
          Your Cart is Empty
        </h2>
        <p class="text-sm sm:text-base text-gray-500 max-w-md mb-6 leading-relaxed">
          Looks like you haven't added anything to your cart yet. Explore our wide range of scrap and vehicle parts to
          find what you need.
        </p>

        <!-- Action Buttons -->
        <div class="flex flex-wrap items-center justify-center gap-3 w-full sm:w-auto">
          <button type="button" (click)="continueShopping()"
            class="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-2.5 text-sm sm:text-base font-semibold text-white bg-[#0A0A5F] hover:bg-blue-900 rounded-lg shadow-sm transition-all duration-200 cursor-pointer active:scale-95">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
            </svg>
            <span>Explore Products</span>
          </button>
          <button *ngIf="!isLogging" type="button" (click)="openLoginPopup('other')"
            class="w-full sm:w-auto inline-flex items-center justify-center px-6 py-2.5 text-sm sm:text-base font-semibold text-[#0A0A5F] bg-white border border-[#0A0A5F] hover:bg-blue-50 rounded-lg shadow-2xs transition-all duration-200 cursor-pointer active:scale-95">
            <span>Sign In to Your Account</span>
          </button>
        </div>

      </div>

    </div>
  </section>

  <!-- Mobile Fixed Bottom Bar -->
  <div *ngIf="!isCartEmpty() && !isCartLoading"
    class="block md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-2xl z-[45]">
    <div *ngIf="paymentErrorMessage"
      class="mx-4 mt-2 px-3 py-2 rounded-lg bg-red-50 border border-red-200 text-red-700 text-xs">
      {{ paymentErrorMessage }}
    </div>
    <div class="flex items-center justify-between p-3.5 sm:p-4 gap-2">
      <div class="min-w-0">
        <p class="text-xs text-gray-600">Total Amount</p>
        <p class="text-base sm:text-lg font-bold text-[#0A0A5F] truncate">₹{{ getDisplayTotalAmount() }}</p>
      </div>
      <div class="flex items-center gap-2 flex-shrink-0">
        <button *ngIf="lable === 'Make Payment'" (click)="onMakeEnquiry()"
          [disabled]="selectedItems.size === 0 || (payment && userData && !canPlaceOrder)"
          [class.opacity-60]="selectedItems.size === 0 || (payment && userData && !canPlaceOrder)"
          class="flex-shrink-0 px-3 sm:px-4 py-2.5 text-xs sm:text-sm font-bold text-center text-white whitespace-nowrap rounded-lg bg-[#0A0A5F] cursor-pointer">
          Enquire Now
        </button>
        <button (click)="gotoPayment()" [disabled]="payment && userData && !canPlaceOrder"
          [class.opacity-60]="payment && userData && !canPlaceOrder"
          class="flex-shrink-0 px-4 sm:px-6 py-2.5 text-xs sm:text-sm font-medium text-white whitespace-nowrap rounded-lg bg-[#0A0A5F] cursor-pointer">
          {{ lable }}
        </button>
      </div>
    </div>
  </div>
</main>
<!-- model popup left side -->

<div *ngIf="Sidefilter" class="fixed inset-0 bg-black bg-opacity-50 z-[90]" (click)="closeModal()"></div>

<section
  class="bg-white max-w-[484px] fixed right-0 top-0 h-full max-md:fixed max-md:inset-x-0 max-md:bottom-0 max-md:top-auto max-md:h-auto max-md:max-h-[90vh] shadow-lg transform transition-transform duration-300 z-[100] w-full sm:w-[484px] max-md:rounded-2xl max-md:flex max-md:flex-col"
  [class.invisible]="!Sidefilter" [class.pointer-events-none]="!Sidefilter"
  [ngClass]="Sidefilter ? 'translate-x-0 max-md:translate-x-0 max-md:translate-y-0' : 'translate-x-full max-md:translate-x-0 max-md:translate-y-full'">
  <!-- Header -->
  <header
    class="flex flex-col justify-center px-6 py-4 w-full text-2xl font-bold leading-none bg-white max-md:rounded-t-2xl border-b border-solid border-b-[color:var(--Input-field-Stroke,#D4D4D4)] text-blue-950 max-md:px-5 max-md:shrink-0">
    <div class="flex gap-10 justify-between items-start w-full">
      <h1 *ngIf="type === 'billing'">Select Billing Address</h1>
      <h1 *ngIf="type !== 'billing'">Select Address</h1>
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/8b6c08b8f398b49c9e660c78975ef334b44714be?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
        alt="Close" class="object-contain shrink-0 w-8 aspect-square cursor-pointer" (click)="closeModal()" />
    </div>
  </header>

  <!-- Scrollable Content -->
  <div
    class="overflow-y-auto px-6 mt-6 pb-32 h-[calc(100vh-132px)] max-md:px-5 max-md:mt-4 max-md:pb-4 max-md:flex-1 max-md:min-h-0">
    @if(addresses.length > 0) {

    <div *ngFor="let address of addresses; let i = index" [ngClass]="{ 'mt-2': i > 0 }">
      <article class="flex flex-col justify-center py-2 w-full bg-white">
        <div class="flex gap-2 items-start w-full rounded-lg">
          <input type="radio" name="addressRadio" class="object-contain shrink-0 w-4 aspect-square cursor-pointer"
            [(ngModel)]="testValue" [value]="address.id" />
          <div class="flex flex-col flex-1 min-w-60">
            <header class="flex gap-1 items-center font-bold">
              <h3 class="text-black">
                {{ address?.receiver_name || address?.company_name || userData?.account_name }},
              </h3>
              <span class="text-black">{{ address?.pincode }}</span>
            </header>
            <p class="mt-1 font-medium leading-6 text-neutral-500">
              {{ address?.address_1 }}
              <span *ngIf="address?.land_mark">, {{ address?.land_mark }}</span>
              <span *ngIf="address?.city">, {{ address?.city }}</span>
              <span *ngIf="address?.state">, {{ address?.state }}</span>
              <span *ngIf="address?.pincode">, {{ address?.pincode }}</span>
            </p>
            <p *ngIf="address?.receiver_phone_no || address?.phone_no" class="mt-1 text-sm text-gray-600">
              Phone: {{ address?.receiver_phone_no || address?.phone_no }}
            </p>
          </div>
        </div>
      </article>
    </div>
    }
    @else {
    <div class="flex flex-col justify-center py-2 w-full bg-white">
      <p class="text-gray-500">No addresses found</p>
    </div>
    }
  </div>

  <!-- Footer -->
  <footer
    class="flex flex-wrap gap-6 items-center px-6 py-2 w-full font-bold text-center bg-white border-t border-solid border-t-[color:var(--Neutrals-Light-Gray,#C0C5C7)] absolute bottom-0 max-md:px-5 max-md:relative max-md:shrink-0">
    <button class="flex flex-1 gap-1 justify-center items-center p-3 rounded-lg border text-blue-950 whitespace-nowrap"
      (click)="addNewAddress()">
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/2d38e86aa9802372fe8d74f0ea1246427ad41107?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
        alt="Add" class="w-6 aspect-square" />
      <span *ngIf="type === 'billing'">Add Billing Address</span>
      <span *ngIf="type !== 'billing'">Add Address</span>
    </button>

    <button class="flex flex-1 gap-1 justify-center items-center p-3 text-white rounded-lg bg-blue-950"
      (click)="applySelection()">
      <span>Apply</span>
    </button>
  </footer>
</section>

<div *ngIf="showAddAddressSection">
  <app-address (close)="onClose()" (save)="onSave()" [type]="type"></app-address>
</div>
<div *ngIf="showGstinSection">
  <app-gst (close)="onClose()" (save)="onSave()"></app-gst>
</div>
<div *ngIf="showCouponSection">
  <app-coupon [availableCoupons]="availableCoupons" [currentSelectedCoupon]="selectedCoupon" (close)="onClose()"
    (save)="onSaveCouponDetails($event)">
  </app-coupon>
</div>

<!-- Login Popup Modal -->
<div *ngIf="showLoginModal" id="authentication-modal"
  class="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50" tabindex="-1" aria-hidden="true" (click)="onLoginBackdropClick($event)">
  <div
    class="relative bg-white rounded-lg shadow w-full h-full sm:w-auto sm:h-auto sm:max-w-4xl sm:max-h-[90vh] sm:overflow-auto">
    <app-login (loginSuccess)="closeLoginPopup()" [actionType]="currentAction">
    </app-login>
  </div>
</div>

<!-- Confirmation Modal for Removing All Items -->
<div *ngIf="showConfirmRemoveAllModal" class="fixed inset-0 z-[110] flex items-center justify-center p-4">
  <div class="fixed inset-0 bg-black/50" (click)="cancelRemoveAll()"></div>
  <div class="relative bg-white rounded-xl shadow-2xl max-w-sm w-full mx-auto z-10 overflow-hidden"
    (click)="$event.stopPropagation()">
    <div class="px-6 pt-6 pb-2">
      <h3 class="text-lg font-bold text-gray-900">Remove All Items</h3>
    </div>
    <div class="px-6 pb-5">
      <p class="text-sm text-gray-600">Are you sure you want to remove all selected items from your cart?</p>
    </div>
    <div class="px-6 pb-6 flex gap-3">
      <button type="button" (click)="executeRemoveAllItems()"
        class="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-semibold text-sm rounded-lg transition-colors cursor-pointer">
        Yes, Remove All
      </button>
      <button type="button" (click)="cancelRemoveAll()"
        class="flex-1 px-4 py-2 border border-gray-300 hover:bg-gray-50 text-gray-700 font-semibold text-sm rounded-lg transition-colors cursor-pointer">
        Cancel
      </button>
    </div>
  </div>
</div>